import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=9a1a8248&scoped=true&lang=pug&"
import script from "./Logout.vue?vue&type=script&lang=js&"
export * from "./Logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1a8248",
  null
  
)

export default component.exports